import { Text, Box, Flex } from '@updater/ui-uds';

import { GridCardProps } from './LogoGridCard.types';

import {
  GridCardColumnBottom,
  GridCardColumnTop,
  GridCardColumn,
  GridCardSubTitle,
  GridCardColumnSuccess,
  GridCardColumnButton,
  GridCardLogo,
  GridCardCTA,
  GridCardColumnSuccessIcon,
} from './LogoGridCard.styles';

export const LogoSuccessMessage: React.FC<{ successCopy: string }> = ({
  successCopy,
}) => (
  <GridCardCTA>
    <GridCardColumnSuccess>
      <GridCardColumnSuccessIcon>
        <svg
          height="24"
          width="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="12" cy="12" r="12" fill="#62CE91" />
          <path d="M16.0004 9L10.0001 15L7 12.0001" fill="#62CE91" />
          <path
            d="M16.0004 9L10.0001 15L7 12.0001"
            stroke="white"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </GridCardColumnSuccessIcon>
      <Text as="span" variant="s" color="gray20">
        {successCopy}
      </Text>
    </GridCardColumnSuccess>
  </GridCardCTA>
);

/**
 * A child component for GridLayout which provides a card as a column within a grid
 */
export const LogoGridCard: React.FC<GridCardProps> = ({
  title,
  subtitle,
  onClick = () => {},
  logo,
  span = '3',
  spanStart,
}) => {
  return (
    <GridCardColumn
      data-cy="utilityCard"
      borderColor={'light' as any}
      variant="squared"
      spanStart={spanStart}
      span={span}
    >
      <GridCardColumnTop>
        <GridCardLogo data-cy="utilityCardTop" data-testid="utilityCardTop">
          {logo}
        </GridCardLogo>
        <Box paddingLeft={['m']} pt="s">
          {title ? (
            <Text as="h2" variant="lBold" color="primary" mb="xs">
              {title}
            </Text>
          ) : null}
          {subtitle ? (
            <GridCardSubTitle as="span" variant="m" color="primary">
              {subtitle}
            </GridCardSubTitle>
          ) : null}
        </Box>
      </GridCardColumnTop>
      <GridCardColumnBottom data-cy="utilityCardBottom">
        <Flex
          flexDirection="row"
          justifyContent="space-between"
          alignItems="center"
          width="100%"
        >
          <Text variant="m">Get Started</Text>
          <GridCardColumnButton onClick={onClick} size="s" variant="primary">
            Go
          </GridCardColumnButton>
        </Flex>
      </GridCardColumnBottom>
    </GridCardColumn>
  );
};
